export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f74f78d14826f69abab06f67ad5efe721064552f3&name=fetchTypeahead!'